import React from "react";
import HeroSection from "./HeroSection";

const HomePage = () => {
  return (
    <main className="md:-tw-mx-32 -tw-mx-3 -tw-mt-40 -md:tw-mt-44 tw-flex tw-flex-col tw-items-center">
      <HeroSection />

      {/* Spacer - adjust height as needed */}
      {/* <div className="tw-h-32" /> */}
    </main>
  );
};

export default HomePage;
